module.exports = __webpack_public_path__ + "static/media/BM_InspectionStatus.2473128d.svg";